"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntersectionObserver = require("react-intersection-observer");
var _excluded = ["src", "fallbackImage", "alt"];
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var defaultFallback = 'https://media.angi.com/sites/all/themes/altheme/images/white.gif';
function LazyImage(_ref) {
  var src = _ref.src,
    _ref$fallbackImage = _ref.fallbackImage,
    fallbackImage = _ref$fallbackImage === void 0 ? defaultFallback : _ref$fallbackImage,
    alt = _ref.alt,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useInView = (0, _reactIntersectionObserver.useInView)({
      triggerOnce: true
    }),
    _useInView2 = (0, _slicedToArray2["default"])(_useInView, 2),
    targetElement = _useInView2[0],
    inView = _useInView2[1];
  var _useState = (0, _react.useState)(fallbackImage),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    imageUrl = _useState2[0],
    setImageUrl = _useState2[1];
  (0, _react.useEffect)(function () {
    return setImageUrl(inView ? src : fallbackImage);
  }, [inView, src]);
  return /*#__PURE__*/_react["default"].createElement("img", (0, _extends2["default"])({
    ref: targetElement,
    src: imageUrl,
    alt: alt
  }, rest));
}
LazyImage.defaultProps = {
  fallbackImage: defaultFallback
};
LazyImage.propTypes = {
  src: _propTypes["default"].string.isRequired,
  alt: _propTypes["default"].string.isRequired,
  fallbackImage: _propTypes["default"].string
};
var _default = exports["default"] = LazyImage;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/LazyImage.js
// module id = 6330
// module chunks = 25